"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnImageSlider = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("swiper/react");
const swiper_1 = __importStar(require("swiper"));
// Import Swiper styles
// import 'swiper/css';
swiper_1.default.use([swiper_1.Autoplay]);
function ColumnImageSlider(_a) {
    var { className, children, autoPlay = true, autoPlayDelay = 5000 } = _a, props = __rest(_a, ["className", "children", "autoPlay", "autoPlayDelay"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_2.Swiper, Object.assign({ slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 30, watchOverflow: true, resizeObserver: false, autoplay: autoPlay
                ? {
                    delay: autoPlayDelay,
                    disableOnInteraction: false,
                }
                : false, className: (0, classnames_1.default)('image-slider', className) }, props), react_1.default.Children.map(children, (child) => (react_1.default.createElement(react_2.SwiperSlide, null, child))))));
}
exports.ColumnImageSlider = ColumnImageSlider;
